import { useState } from 'react'

import { MapAndGrid } from './MapAndGrid'
import { useDeviceType } from '@gravitate-js/excalibrr'

export function StoreDashboard() {
  const [highlightedStore, setHighlightedStore] = useState()
  const { isMobile } = useDeviceType()

  return (
    <div className='flex' style={{ overflow: 'hidden', height: isMobile ? '100%' : 'calc(100vh - 90px)' }}>
      <MapAndGrid setHighlightedStore={setHighlightedStore} highlightedStore={highlightedStore} />
    </div>
  )
}
